// Indicates the application's state in terms of onboarding, i.e. if there
// is a mandate in progress
export enum AppOnboardingState {
  None,
  InProgress,
  Complete
}
